TrelloModel = require 'app/scripts/models/internal/trello-model'

class CheckItem extends TrelloModel
  typeName: 'CheckItem'
  urlRoot: ->
    checklist = @getChecklist()
    "#{ checklist.getCard().url() }/checklist/#{ checklist.id }/checkItem"

  sync: (method, model, options) ->
    # We can't sync our checkItem models until we know the id of the checklist
    # the check item is being added to
    if !@getChecklist()?
      return
    @waitForId @getChecklist(), =>
      super(method, model, options)

  getChecklist: -> @collection.sourceModel

  getCard: -> @getChecklist().getCard()

  getBoard: -> @getCard().getBoard()

  editable: -> @getChecklist().editable()

  getContext: -> @getChecklist()

  move: (index) ->
    @update('pos', @getChecklist().calcPos(index, @))
    @collection.sort({ silent: true })
    return

module.exports = CheckItem
